import { Popover } from '@sunwebgroup/uds-ui/popover'
import { equals, reject } from 'ramda'
import * as React from 'react'
import { useCustomDesktop } from '../../useCustomDesktop'
import { DropdownMultiselectContext } from './context'

interface DropdownProps extends React.HTMLProps<HTMLDivElement> {
  placeholder?: string
  value: string[]
  open?: boolean
  onOpenChange?: (open: boolean) => void
  onValueChange?: (newValue: string[]) => void
}

export function Root({
  className,
  children,
  placeholder,
  disabled,
  value,
  open,
  onOpenChange,
  onValueChange,
}: DropdownProps) {
  const handleOptionAdd = React.useCallback(
    (addedValue: string) => {
      onValueChange?.([...value, addedValue])
    },
    [onValueChange, value],
  )

  const handleOptionRemove = React.useCallback(
    (removedValue: string) => {
      onValueChange?.(reject(equals(removedValue), value))
    },
    [onValueChange, value],
  )

  const handleOptionsAdd = React.useCallback(
    (addedValues: string[]) => {
      onValueChange?.([...value, ...addedValues])
    },
    [onValueChange, value],
  )

  const handleOptionsRemove = React.useCallback(
    (removedValues: string[]) => {
      onValueChange?.(value.filter(val => !removedValues.includes(val)))
    },
    [onValueChange, value],
  )

  const contextValue = React.useMemo(
    () => ({
      placeholder,
      disabled,
      selectedValues: value,
      removeOption: handleOptionRemove,
      addOption: handleOptionAdd,
      removeOptions: handleOptionsRemove,
      addOptions: handleOptionsAdd,
    }),
    [placeholder, disabled, value, handleOptionRemove, handleOptionAdd, handleOptionsRemove, handleOptionsAdd],
  )

  const isCustomDesktop = useCustomDesktop()
  const isBehavesAsModal = !isCustomDesktop

  return (
    <div className={className}>
      <DropdownMultiselectContext value={contextValue}>
        <Popover.Root open={disabled ? false : open} onOpenChange={onOpenChange} modal={isBehavesAsModal}>
          {children}
        </Popover.Root>
      </DropdownMultiselectContext>
    </div>
  )
}
